import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/style/pageStyle/surverManager.scss";
import { Col, Row } from "antd";
import InputSearchBox from "../../components/common/Input/InputSearchBox";
import BaseButton from "../../components/common/Button/BaseButton";
import { IconPlus } from "../../assets/icon";
import TableSurvey from "../../components/common/Table/TableSurvey";
import {
  resetStatus,
  setOpenModalAddSurvey,
  setOpenModalGetLogSurvey,
  setSearchText,
} from "../../services/slice/SurveySlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { surveySelector } from "../../services/selector/index.";
import ModalAddSurvey from "../../components/common/Modal/add/ModalAddSurvey";
import ModalEditSurvey from "../../components/common/Modal/edit/ModalEditSurvey";
import Notify from "../../components/common/Notify";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
const SurverManager = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const {
    isOpenModalAddSurvey,
    isOpenModalEditSurvey,
    isNotify,
    msg,
    typeNotify,
    dataLog,
    isOpenModalGetLog,
  } = surveyState;

  return (
    <>
      {isOpenModalAddSurvey ? (
        <div>
          <ModalAddSurvey title={"Thêm mới khảo sát"} />
        </div>
      ) : null}
      {isOpenModalGetLog && (
        <ModalGetLog
          open={isOpenModalGetLog}
          setOpen={setOpenModalGetLogSurvey}
          data={dataLog}
        />
      )}
      {isOpenModalEditSurvey ? (
        <div>
          <ModalEditSurvey title={"Chỉnh sửa khảo sát"} />
        </div>
      ) : null}
      <div className="containerContentPage wrapperSurverManager">
        <div className="headerPage">
          <h2 className="title">{t("Quản lý khảo sát")}</h2>
        </div>
        <Notify
          isNotify={isNotify}
          reset={resetStatus}
          title={"Bkav Pro"}
          content={msg}
          type={typeNotify}
        />
        <Row style={{ width: "100%" }}>
          <Col className="mr-5">
            <InputSearchBox
              setText={(value) => {
                dispatch(setSearchText(value));
              }}
              width={435}
              placeholder={"Tìm kiếm theo tên cuộc khảo sát"}
            />
          </Col>

          <Col
            className="ml-5"
            style={{
              flexGrow: "1",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <BaseButton
              handleClick={() => dispatch(setOpenModalAddSurvey(true))}
              width={120}
              typeBtn={"btnOrange"}
              icon={
                <IconPlus
                  width={16}
                  height={14}
                  style={{ marginRight: "0.5rem" }}
                />
              }
              content={`Thêm mới`}
            />
          </Col>
        </Row>
        <TableSurvey />
      </div>
    </>
  );
};

export default SurverManager;
